const book = { label: 'Book', kind: 'book' };
const person = { label: 'Name', kind: 'person' };

// Full-page fallbacks share the same structure and vocabulary as their destination.
const layouts = {
    '/books/admin/all': { columns: [book, 'Publisher', 'Price', 'Availability', 'Actions'] },
    '/books/admin/my-books': { columns: [book, 'Category', 'Price', 'Status', 'Actions'] },
    '/books/institution': { columns: [book, 'Purchased copies', 'Assigned users', 'Subject groups', 'Actions'] },
    '/books/institution-picks': { columns: [book, 'Category', 'Assigned users', 'Subject groups', 'Actions'] },
    '/admin/physical-books': { columns: [book, 'ISBN', 'Price', 'Stock', 'Actions'] },
    '/users/admin/all': { columns: [person, 'Contact details', 'Roles', 'Status', 'Actions'] },
    '/users/institution': { columns: [person, 'Email', 'Mobile number', 'Actions'] },
    '/users/publisher': { columns: [person, 'Email', 'Mobile number', 'Actions'] },
    '/users/admin/couriers': { columns: [person, 'Contact details', 'Actions'] },
    '/publishers': { columns: ['Publisher', 'Contact details', 'Status', 'Actions'] },
    '/institutions': { columns: ['Institution', 'Contact details', 'Country', 'Actions'] },
    '/subject-groups': { columns: ['Subject group', 'Students', 'Actions'] },
    '/brand-ambassadors': { columns: [person, 'Contact details', 'Commission', 'Actions'] },
    '/orders': { columns: ['Order', 'Customer', 'Amount', 'Payment method', 'Status'] },
    '/orders-to-assign': { columns: ['Order', 'Customer', 'Delivery address', 'Courier', 'Status'] },
    '/audit-trail': { columns: ['Action', 'User', 'Description', 'Date'] },
    '/error-report': { columns: ['Report', 'Message', 'File', 'Reported at', 'Actions'] },
    '/books/admin/tags': { columns: ['Tag', 'Book usage', 'Actions'] },
    '/books/admin/genres-and-categories': { variant: 'list' },
    '/roles-and-permissions': { variant: 'permissions' },
    '/configurations': { variant: 'settings' },
    '/admin/payment-methods': { variant: 'settings' },
    '/admin/currencies': { columns: ['Currency', 'Exchange rate', 'Status', 'Last updated', 'Actions'] },
    '/admin/service-tokens': { columns: ['Service', 'Token', 'Permissions', 'Status', 'Last used', 'Expires', 'Actions'] },
    '/admin/subscription-plans': { columns: ['Plan name', 'Category', 'Price', 'Duration', 'Credits', 'Access limit', 'Visibility'] },
    '/vouchers': { variant: 'vouchers' },
    '/portal-profile': { variant: 'profile' },
    '/pay-publisher': { variant: 'form' },
    '/pay-brand-ambassador': { variant: 'form' },
    '/admin/publishers/sold-books-export': { variant: 'form' },
    '/ba/client-payments': { columns: ['Client', 'Payment', 'Commission', 'Date'] },
    '/books/publisher/purchased': { variant: 'books' },
    '/admin/geo-restrictions': { columns: [book, 'Access policy', 'Countries', 'Actions'] },
    '/bulk-book-imports': { variant: 'form' },
    '/upload-books': { variant: 'form' },
};

export function portalLoadingLayout(pathname) {
    if (pathname.startsWith('/portal/users/')) return { variant: 'profile' };
    if (pathname === '/ba-dashboard') return { variant: 'metrics', labels: ['Clients', 'Payments', 'Commission'] };
    const key = Object.keys(layouts).find((path) => pathname === path || pathname.startsWith(`${path}/`));
    return layouts[key] || { variant: 'table' };
}
